import {PROMOTIONS_QUERY_PARAM_NAME} from "../constants/offer_list";

export const isPromotionsListingQuery = (query: Record<string, string | string[] | null | boolean | undefined>) => query[PROMOTIONS_QUERY_PARAM_NAME] === "1";
import {PROMOTIONS_QUERY_PARAM_NAME} from "../constants/offer_list";

export const isPromotionsListingQuery = (query: Record<string, string | string[] | null | boolean | undefined>) => query[PROMOTIONS_QUERY_PARAM_NAME] === "1";
